import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { DateText } from '~/eds/src/components/DateText/DateText';
import { Text } from '~/eds/src/components/Text/Text';
import { PilotId } from '~/types/PilotId';

import { User } from '../User/User';

interface Props {
  /** User activity string */
  activity: string;
  /** JS Date */
  date: Date;
  /** User ID */
  id: PilotId;
}

export const UserActivity = memo(({ activity, id, date }: Props) => {
  return (
    <Text>
      <FormattedMessage
        id="UserActivity.activityText"
        defaultMessage="{activity} at {date} by {user}"
        description="User activity message showing action, date, and user. Example: activity = 'example', date = '2024-01-15', user = 'John Smith'"
        values={{
          activity,
          date: <DateText date={date} format="short_datetime" />,
          user: <User id={id} mode="name" />,
        }}
      />
    </Text>
  );
});
